import {
  Text,
  View,
  ScrollView,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  Button,
  ActivityIndicator
} from 'react-native'
import { Ionicons } from '@expo/vector-icons'
import * as React from 'react'
// styles
import { colorPalette, fontPalette, globalStyles } from '../../../static/styles/global'
import { en as WelcomeEn } from '../../../i18n/WelcomeScreen'
// screens & components
import Card from '../../../components/shared/card/Card'
import moment from 'moment'
import { Entypo } from '@expo/vector-icons'
import { useEffect, useState } from 'react'
import Calendar_Stripe from '../../../components/shared/calendar/calender_strip'
import { useLabourStore } from '../../../stores/labour'
import CardSeparator from '../../../components/shared/card/CardSeparator'
import { useTranslation } from 'react-i18next'
import HomeDetailsHeader from '../../../components/home/HomeDetailsHeader'
import { convertTo12HourTime } from '../../../utils'
import { useshiftstore } from '../../../stores/shift'
import { useHomeStore } from '../../../stores/home'
import { useInitializeStore } from '../../../stores/initialize'
import { useFocusEffect } from '@react-navigation/native'

const LaborSavorSchedule = ({ navigation, route }): JSX.Element => {
  const [customerShifts, setCustomerShifts] = React.useState([])
  const [customerShiftInfo, setUpdateShiftInfo] = React.useState([])
  const [showHide, setShowHide] = React.useState(Array(15).fill(false))
  const [visible, setVisible] = React.useState(Array(15).fill(false))
  const [showShData, setUpdateShiftShow] = React.useState(false)
  const [shift, setShift] = React.useState('')
  const [nextshift, setNextshift] = React.useState('')
  const { t } = useTranslation()

  const changeCalendarLabel = (day) => {
    // console.log(shiftInfoData.length)
    //console.log(day)
    // if (day === '2023-07-06') {
    //   setUpdateShiftShow(!showShData)
    // }
  }

  const { params } = route
  const { mostRecentUserOnBoardings: Id, refresh, weekNo } = params

  const labourStore = useLabourStore()
  const shiftStore = useshiftstore()
  const homestore = useHomeStore()

  function formattingdate(inputDate) {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ]

    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday'
    ]

    const dateParts = inputDate?.split('T')[0]?.split('-')
    const year = dateParts[0]
    const month = months[parseInt(dateParts[1], 10) - 1]
    const day = parseInt(dateParts[2], 10)
    const inputDateObject = new Date(inputDate)
    const dayOfWeek = days[inputDateObject.getDay()]
    const nextShiftMessage = `${t('next_shift_starts_on')} ${t(dayOfWeek)}, ${month} ${day}`;
    setNextshift(nextShiftMessage)
  }
  const scheduleshifts = labourStore?.scheduleData?.shiftInfo
  const updateddata = () => {
    const updatedShifts = []
    if (labourStore?.scheduleData != null) {
      labourStore?.scheduleData?.shiftInfo?.forEach((item) => {
        const apiResponse = item.date
        const dateObject = new Date(apiResponse)
        const year = dateObject.getFullYear()
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0')
        const day = dateObject.getDate().toString().padStart(2, '0')
        const formattedDate = `${year}-${month}-${day}`
        if (!item.onLeave) {
          updatedShifts.push({ day: formattedDate })
        }
        setCustomerShifts(updatedShifts)
      })
      const today = new Date()
      const todayDate = today.getDate()
      const currentMonth = today.getMonth() + 1
      const currentYear = today.getFullYear()
      const todayDateString = `${currentYear}-${currentMonth
        .toString()
        .padStart(2, '0')}-${todayDate.toString().padStart(2, '0')}`
      const currentWeekStart = new Date(today)
      currentWeekStart.setDate(todayDate - today.getDay())

      const currentWeekEnd = new Date(today)
      currentWeekEnd.setDate(todayDate + (6 - today.getDay()))
      const dates = labourStore?.scheduleData?.shiftInfo?.filter(
        (item) =>
          new Date(item.date) >= currentWeekStart &&
          new Date(item.date) <= currentWeekEnd &&
          new Date(item.date) > new Date(today)
      )
      if (dates[0] != null) {
        {
          formattingdate(dates[0]?.date)
        }
      }
    }
  }

  useEffect(() => {
    updateddata()
  }, [labourStore.scheduleData])

  const intializestore = useInitializeStore()
  const handleWeekChange = (newSunday, newSaturday) => {


    setShowHide((prevShowHide) => {
      const updatedShowHide = Array(prevShowHide.length).fill(false)
      return updatedShowHide
    })
  }

  useFocusEffect(
    React.useCallback(() => {
      const fetchData = () => {
        shiftStore.getopenshifts(
          intializestore.initializeData.userkey,
          moment().format('YYYY-MM-DD'),
          moment().endOf('year').format('YYYY-MM-DD')
        )

        labourStore.schedulefetchData(
          labourStore?.labourData?.userId ? labourStore?.labourData?.userId : 0,
          labourStore?.startWeekDate,
          labourStore?.endWeekDate
        )
      }
      fetchData()
      const intervalId = setInterval(fetchData, 60000)
      return () => clearInterval(intervalId)
    }, [labourStore.startWeekDate])
  )

  const openshiftslength = shiftStore?.openshiftsData?.openShifts?.length
  const [showHide2, setShowHide2] = React.useState(
    Array(openshiftslength).fill(false)
  )
  const [visible2, setVisible2] = React.useState(
    Array(openshiftslength).fill(false)
  )
  const hasMultipleDepartments = (data) => {
    const departmentNames = data.map((item) => item.departmentName)
    const uniqueDepartmentNames = new Set(departmentNames.filter(Boolean))
    return uniqueDepartmentNames.size > 1
  }
  const [selectedTab, setSelectedTab] = useState(0)

  function calculateTotalTime(scheduleArray) {
    let totalHours = 0
    let totalMinutes = 0

    scheduleArray.forEach((obj) => {
      const [hours, minutes] = obj.scheduleHours?.split(':').map(Number)
      totalHours += hours
      totalMinutes += minutes
    })

    totalHours += Math.floor(totalMinutes / 60)
    totalMinutes %= 60

    return { totalHours, totalMinutes }
  }
  let totaltime

  if (scheduleshifts) {
    totaltime = calculateTotalTime(scheduleshifts)
  }

  const mergedArray: any = [
    ...labourStore?.scheduleData?.shiftInfo,
    ...labourStore?.scheduleData?.ptoInfo
  ]

  for (let i = 0; i < mergedArray.length; i++) {
    for (let j = i + 1; j < mergedArray.length; j++) {
      const dateI = new Date(mergedArray[i].date || mergedArray[i].startTimeOff)
      const dateJ = new Date(mergedArray[j].date || mergedArray[j].startTimeOff)

      if (dateI > dateJ) {
        const temp = mergedArray[i]
        mergedArray[i] = mergedArray[j]
        mergedArray[j] = temp
      }
    }
  }


  function getPTODisplayTime(ptohours) {
    const str = ptohours.toString();
    const [hours, minutes] = str?.split('.');

    const formattedHours = hours.padStart(2, '0');
    const formattedMinutes = (minutes ? minutes.padEnd(2, '0') : '00').slice(0, 2);

    return `(Hrs. ${formattedHours}:${formattedMinutes})`;
  }


  return (
    <ScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader />
        </View>
        {selectedTab == 0 ? (
          <Text
            style={{
              color: 'white',
              textAlign: 'center',
              fontFamily: fontPalette.primaryBold,
              fontSize: 24
            }}
          >
            {t('My Shifts')}
          </Text>
        ) : (
          <Text
            style={{
              color: 'white',
              textAlign: 'center',
              fontFamily: fontPalette.primaryBold,
              fontSize: 24
            }}
          >
            {t('Open Shifts')}
          </Text>
        )}
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View style={{ justifyContent: 'center', alignItems: 'center' }}>
            <View
              style={{
                width: '100%',
                height: 40,
                borderWidth: 0.5,
                backgroundColor: 'white',
                borderRadius: 17,
                flexDirection: 'row',
                alignItems: 'center'
              }}
            >
              <TouchableOpacity
                style={{
                  width: '50%',
                  height: 38,
                  backgroundColor: selectedTab == 0 ? colorPalette.skyBlue : 'white',
                  borderRadius: 15,
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                onPress={() => setSelectedTab(0)}
              >
                <Text
                  style={{
                    color: selectedTab == 0 ? '#fff' : '#000',
                    fontSize: 18,
                    fontFamily: fontPalette.primaryBold
                  }}
                >
                  {t('My Shifts')}
                </Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={{
                  width: '50%',
                  height: 38,
                  backgroundColor: selectedTab == 1 ? colorPalette.skyBlue : 'white',
                  borderRadius: 15,
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
                onPress={() => setSelectedTab(1)}
              >
                <Text
                  style={{
                    color: selectedTab == 1 ? '#fff' : '#000',
                    fontSize: 18,
                    fontFamily: fontPalette.primaryBold
                  }}
                >
                  {t('Open Shifts')}{' '}
                  {shiftStore.openshiftsData?.openShifts?.length > 0
                    ? `(${shiftStore.openshiftsData?.openShifts?.length})`
                    : ''}
                </Text>
              </TouchableOpacity>
            </View>
            {selectedTab == 0 ? (
              <View style={{ width: '100%' }}>
                <Calendar_Stripe
                  headerShow={false}
                  onChangeValue={changeCalendarLabel}
                  customerShifts={customerShifts}
                  shiftInfo={true}
                  shiftInfoText={`${nextshift}`}
                  onChangeWeek={handleWeekChange}
                  currentPosition={weekNo}
                />
                {showShData && (
                  <View style={{ marginTop: 10 }}>
                    {customerShiftInfo.map((item) => (
                      <View style={{ flex: 1, marginBottom: 8 }} key={item.id}>
                        <Text>{item.info}</Text>
                      </View>
                    ))}
                  </View>
                )}
                <CardSeparator />

                {!labourStore?.loading && parseInt(totaltime.totalHours) > 0 && (
                  <Text
                    style={{ fontFamily: fontPalette.primaryBold, fontSize: 16 }}
                  >{`${t('total_scheduled_hours')} : (Hrs. ${totaltime.totalHours
                    .toString()
                    .padStart(2, '0')}:${totaltime.totalMinutes
                      .toString()
                      .padStart(2, '0')})`}</Text>
                )}

                {labourStore?.loading ? (
                  <ActivityIndicator size="large" color="#0099E5" />
                ) : mergedArray && mergedArray.length ? (
                  mergedArray.map((item, index) => {
                    if (item.date !== undefined) {
                      const date = new Date(item.date)

                      const dayOfMonth = date.getDate()
                      const dayOfWeek = date.getDay()
                      const daysOfWeek = [
                        'Sun',
                        'Mon',
                        'Tues',
                        'Wed',
                        'Thur',
                        'Fri',
                        'Sat'
                      ]
                      const dayName = daysOfWeek[dayOfWeek]
                      const time_In = convertTo12HourTime(item.time_In)
                      const time_Out = convertTo12HourTime(item.time_Out)
                      const schedulehr = item.scheduleHours
                      const shiftiD = item.shiftID
                      const formattedDate = item.date
                      const day = moment(formattedDate).format('YYYY-MM-DD')

                      const apidate = moment(formattedDate).format('YYYY-MM-DD')
                      const TodayDate = moment().format('YYYY-MM-DD')
                      const UserAlreadyGiveUp = item.userAlreadyGiveUp
                      const Message = t(item.userMesssage)
                      const userAlreadySwap = item.userAlreadySwap
                      const userSwapMesssage = t(item.userSwapMesssage)
                      const schedulehours = item.scheduleHours
                      const status = item.shiftStatus
                      const userTimeOffMessage = t(item.userTimeOffMesssage)
                      const userAlreadyTimeOff = item.userAlreadyTimeOff
                      return (
                        <View key={index} style={globalStyles.mt2}>
                          <View style={{ flex: 1, flexDirection: 'row' }}>
                            <View>
                              <TouchableOpacity
                                onPress={() => {
                                  setShowHide((prevShowHide) => {
                                    const updatedShowHide = prevShowHide.map(
                                      (_, i) =>
                                        i === index ? !prevShowHide[i] : false
                                    )

                                    if (!showHide[index]) {
                                      shiftStore.getshifttimings(
                                        apidate,
                                        labourStore?.labourData?.userId
                                          ? labourStore?.labourData?.userId
                                          : 0,
                                        labourStore?.labourData?.entityId,
                                        homestore.homeData.laborSaverStoreID
                                      )
                                    }

                                    return updatedShowHide
                                  })
                                }}
                              >
                                <View
                                  style={{
                                    justifyContent: 'center',
                                    padding: 10,
                                    backgroundColor:
                                      new Date(item.date).toDateString() ===
                                        new Date().toDateString()
                                        ? '#0B495C'
                                        : 'gray',
                                    width: 70,
                                    height: 70,
                                    borderRadius: 5
                                  }}
                                >
                                  <Text
                                    style={{
                                      fontSize: 25,
                                      textAlign: 'center',
                                      color: 'white'
                                    }}
                                  >
                                    {dayOfMonth}
                                  </Text>
                                  <Text
                                    style={{
                                      fontSize: 16,
                                      textAlign: 'center',
                                      color: 'white'
                                    }}
                                  >
                                    {dayName}
                                  </Text>
                                </View>
                              </TouchableOpacity>
                            </View>
                            <View style={{ width: '85%', marginLeft: 10 }}>
                              <Text style={{ color: 'red', fontFamily: fontPalette.primaryBold }}>{Message}</Text>
                              <Text style={{ color: 'red', fontFamily: fontPalette.primaryBold }}>
                                {userSwapMesssage}
                              </Text>
                              <Text style={{ color: 'red', fontFamily: fontPalette.primaryBold }}>
                                {userTimeOffMessage}
                              </Text>
                              <View
                                style={{
                                  flexDirection: 'row',
                                  marginBottom: 0,
                                  justifyContent: 'space-between'
                                }}
                              >
                                <Text
                                  style={{
                                    fontFamily: fontPalette.primaryBold,
                                    marginBottom: 4
                                  }}
                                >
                                  {time_In} - {time_Out}{` `} {`(Hrs. ${moment(schedulehr, 'HH:mm').format('HH:mm')})`}
                                </Text>

                                {day > TodayDate &&
                                  (!UserAlreadyGiveUp || !userAlreadySwap) && (labourStore?.scheduleData?.isShiftRequestAllowed) ? (
                                  <Text style={{ flex: 1, textAlign: 'right' }}>
                                    <TouchableOpacity
                                      onPress={() => {
                                        setVisible((prevVisible) => {
                                          const updatedSelection = [
                                            ...prevVisible
                                          ]
                                          updatedSelection[index] =
                                            !updatedSelection[index]
                                          return updatedSelection
                                        })
                                      }}
                                    >
                                      <Entypo
                                        name="dots-three-horizontal"
                                        size={22}
                                        color={colorPalette.skyBlue}
                                      />
                                    </TouchableOpacity>
                                  </Text>
                                ) : (
                                  <View></View>
                                )}
                              </View>

                              {visible[index] && (
                                <View
                                  style={{
                                    flexDirection: 'column',
                                    justifyContent: 'flex-end',
                                    alignItems: 'flex-end'
                                  }}
                                >
                                  {!UserAlreadyGiveUp && (
                                    <View
                                      style={{
                                        width: '50%',
                                        borderRadius: 10,
                                        backgroundColor: '#EFEFEF',
                                        padding: 10
                                      }}
                                    >
                                      <Text
                                        style={{ color: '#000000', fontFamily: fontPalette.primaryRegular }}
                                        onPress={async () => {
                                          setVisible((prevVisible) => {
                                            const updatedSelection = [
                                              ...prevVisible
                                            ]
                                            updatedSelection[index] =
                                              !updatedSelection[index]
                                            return updatedSelection
                                          })
                                          navigation.navigate('Giveup', {
                                            time_In,
                                            time_Out,
                                            dayOfMonth,
                                            dayName,
                                            shiftiD
                                          })
                                        }}
                                      >
                                        {t('Give Up Shift')}
                                      </Text>
                                    </View>
                                  )}

                                  {!userAlreadySwap && (
                                    <View
                                      style={{
                                        width: '50%',
                                        borderRadius: 10,
                                        backgroundColor: '#EFEFEF',
                                        padding: 10
                                      }}
                                    >
                                      <Text
                                        style={{ color: '#000000', fontFamily: fontPalette.primaryRegular }}
                                        onPress={async () => {
                                          setVisible((prevVisible) => {
                                            const updatedSelection = [
                                              ...prevVisible
                                            ]
                                            updatedSelection[index] =
                                              !updatedSelection[index]
                                            return updatedSelection
                                          })
                                          navigation.navigate('SwapShift', {
                                            time_In,
                                            time_Out,
                                            dayOfMonth,
                                            dayName,
                                            shiftiD
                                          })
                                        }}
                                      >
                                        {t('Swap Shift')}
                                      </Text>
                                    </View>
                                  )}
                                </View>
                              )}
                              <Text>{item.storeName}</Text>
                              <Text>{item.departmentName}</Text>
                            </View>
                          </View>

                          {showHide[index] && (
                            <View style={{ marginTop: 10 }}>
                              <Text style={globalStyles.fwBold}>
                                {t('shift_break_down')} :  {time_In} - {time_Out}{' '}

                              </Text>
                              {shiftStore?.loading ? <ActivityIndicator size="large" color="#0099E5" /> :
                                shiftStore?.shifttimingsData?.data?.map(
                                  (item) => {
                                    if (item.data != null) {
                                      return item.data?.map((sub, index) => {
                                        return (
                                          <View key={index}>
                                            {hasMultipleDepartments(item.data) ? (
                                              <Text
                                                key={
                                                  sub.breakType +
                                                  sub.departmentName
                                                }
                                              >
                                                {t(`shift_keys.${sub.breakType}`)} :{' '}
                                                {moment
                                                  .utc(sub.breakTime)
                                                  .format('LT')}
                                                {/* {moment(sub.breakTime).format('LT')} */}
                                                {'  '}
                                                <Text
                                                  style={{ fontFamily: fontPalette.primaryBold }}
                                                >
                                                  ({sub.departmentName})
                                                </Text>
                                              </Text>
                                            ) : (
                                              <Text key={index}>
                                                {t(`shift_keys.${sub.breakType}`)} :{' '}
                                                {moment
                                                  .utc(sub.breakTime)
                                                  .format('LT')}
                                                {/* {moment(sub.breakTime).format('LT')} */}
                                              </Text>
                                            )}
                                          </View>
                                        )
                                      })
                                    }
                                  }
                                )}
                            </View>
                          )}
                        </View>
                      )
                    } else {
                      const date = new Date(item.startTimeOff)

                      const dayOfMonth = date.getDate()
                      const dayOfWeek = date.getDay()
                      const daysOfWeek = [
                        'Sun',
                        'Mon',
                        'Tues',
                        'Wed',
                        'Thur',
                        'Fri',
                        'Sat'
                      ]
                      const dayName = daysOfWeek[dayOfWeek]
                      const time = item.startTimeOff?.split('T')[1]
                      const starttime = convertTo12HourTime(time)
                      const ptohours = item.ptohours
                      const date1 = item.startTimeOff?.split('T')[0]
                      const time2 = item.endTimeOff?.split('T')[1]
                      const date2 = item.endTimeOff?.split('T')[0]
                      const endtime = convertTo12HourTime(time2)
                      const shiftiD = item.shiftID
                      const formattedDate = item.date
                      const day = moment(formattedDate).format('YYYY-MM-DD')

                      const apidate = moment(formattedDate).format('YYYY-MM-DD')
                      const TodayDate = moment().format('YYYY-MM-DD')
                      const UserAlreadyGiveUp = item.userAlreadyGiveUp
                      const Message = item.userMesssage
                      const userAlreadySwap = item.userAlreadySwap
                      const userSwapMesssage = item.userSwapMesssage
                      const schedulehours = item.scheduleHours
                      const status = item.shiftStatus
                      const userTimeOffMessage = t(item.userTimeOffMesssage)
                      const userAlreadyTimeOff = item.userAlreadyTimeOff
                      const timeOffStatus = item.timeOffStatus

                      return (
                        <View key={index} style={globalStyles.mt2}>
                          <View style={{ flex: 1, flexDirection: 'row' }}>
                            <View>
                              <View
                                style={{
                                  justifyContent: 'center',
                                  padding: 10,
                                  backgroundColor:
                                    new Date(item.date).toDateString() ===
                                      new Date().toDateString()
                                      ? '#0B495C'
                                      : 'gray',
                                  width: 70,
                                  height: 70,
                                  borderRadius: 5
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 25,
                                    textAlign: 'center',
                                    color: 'white'
                                  }}
                                >
                                  {dayOfMonth}
                                </Text>
                                <Text
                                  style={{
                                    fontSize: 16,
                                    textAlign: 'center',
                                    color: 'white'
                                  }}
                                >
                                  {dayName}
                                </Text>
                              </View>
                            </View>
                            <View style={{ width: '85%', marginLeft: 10 }}>


                              <Text style={{ color: timeOffStatus == 1 ? "green" : "red", fontFamily: fontPalette.primaryBold }}>
                                {userTimeOffMessage}
                              </Text>
                              <View
                                style={{
                                  flexDirection: 'row',
                                  justifyContent: 'space-between'
                                }}
                              >
                                {date1 != date2 && (
                                  <Text
                                    style={{
                                      fontFamily: fontPalette.primaryBold,
                                      marginBottom: 4
                                    }}
                                  >
                                    {moment(date1).format('MM/DD/YYYY')} {starttime} -{' '}
                                    {moment(date2).format('MM/DD/YYYY')} {endtime} {' '}
                                    {getPTODisplayTime(ptohours)}

                                    {/* {moment(date1).format('MM/DD/YYYY')} {starttime} -{' '}
                                    {moment(date2).format('MM/DD/YYYY')} {endtime} {' '}
                                    {formatPtoHours(ptohours)} */}
                                  </Text>
                                )}
                                {date1 == date2 && (
                                  <Text
                                    style={{
                                      fontFamily: fontPalette.primaryBold,
                                      marginBottom: 4
                                    }}
                                  >
                                    {starttime} - {endtime}{' '}
                                    {getPTODisplayTime(ptohours)}
                                    {/* {starttime} - {endtime}{' '}
                                    {formatPtoHours(ptohours)} */}
                                  </Text>
                                )}
                              </View>

                              <Text>{item.departmentName}</Text>
                              {item?.timeOffStatus == 2 &&
                                <Text style={{ fontFamily: fontPalette.primaryRegular }}>{item?.employeeComment?.trim()}</Text>}
                            </View>
                          </View>
                        </View>
                      )
                    }
                  })
                ) : (
                  <Text style={{ textAlign: 'center', fontSize: 20, fontFamily: fontPalette.primaryRegular }}>
                    {t('No schedule found for this week')}
                  </Text>
                )}
              </View>
            ) : (
              <View style={{ width: '100%' }}>

                <CardSeparator />
                {shiftStore.openshiftsData?.openShifts.length > 0 ? (
                  shiftStore.openshiftsData?.openShifts.map((item, index) => {
                    const date = new Date(item.shiftData.date)
                    const dayOfMonth = date.getDate()
                    const dayOfWeek = date.getDay()
                    const daysOfWeek = [
                      'Sun',
                      'Mon',
                      'Tues',
                      'Wed',
                      'Thur',
                      'Fri',
                      'Sat'
                    ]
                    const dayName = daysOfWeek[dayOfWeek]
                    const time_In = convertTo12HourTime(item.shiftData.timeIn)
                    const time_Out = convertTo12HourTime(item.shiftData.timeOut)
                    const formattedDate = item.shiftData.date
                    const TodayDate = moment().format('YYYY-MM-DD')
                    const day = moment(formattedDate).format('YYYY-MM-DD')
                    const shiftiD = item.shiftData.shiftId
                    const status = item.userAlreadyAccepted
                    const isShiftRequestAllowed = item.isShiftRequestAllowed
                    return (
                      <View key={index} style={globalStyles.mt2}>
                        <View style={{ flex: 1, flexDirection: 'row' }}>
                          <View>
                            <TouchableOpacity
                              onPress={() => {
                                setShowHide2((prevShowHide) => {
                                  const updatedShowHide = prevShowHide.map(
                                    (_, i) =>
                                      i === index ? !prevShowHide[i] : false
                                  )



                                  return updatedShowHide
                                })
                              }}
                            >
                              <View
                                style={{
                                  justifyContent: 'center',
                                  padding: 10,
                                  backgroundColor:
                                    new Date(
                                      item.shiftData.date
                                    ).toDateString() ===
                                      new Date().toDateString()
                                      ? '#0B495C'
                                      : 'gray',
                                  width: 70,
                                  height: 70,
                                  borderRadius: 5
                                }}
                              >
                                <Text
                                  style={{
                                    fontSize: 25,
                                    textAlign: 'center',
                                    color: 'white'
                                  }}
                                >
                                  {dayOfMonth}
                                </Text>
                                <Text
                                  style={{
                                    fontSize: 16,
                                    textAlign: 'center',
                                    color: 'white'
                                  }}
                                >
                                  {dayName}
                                </Text>
                              </View>
                            </TouchableOpacity>
                          </View>
                          <View style={{ width: '85%', marginLeft: 10 }}>
                            <Text style={{ color: '#FF0000', fontFamily: fontPalette.primaryRegular, }}>
                              {t(item.userMesssage)}
                            </Text>
                            <View
                              style={{
                                flexDirection: 'row',
                                marginBottom: 0,
                                justifyContent: 'space-between'
                              }}
                            >
                              <Text
                                style={{
                                  fontFamily: fontPalette.primaryBold,
                                  marginBottom: 4
                                }}
                              >
                                {time_In}-{time_Out}
                              </Text>

                              {day >= TodayDate && !status && (isShiftRequestAllowed) ? (
                                <Text style={{ flex: 1, textAlign: 'right' }}>
                                  <TouchableOpacity
                                    onPress={() => {
                                      setVisible2((prevVisible) => {
                                        const updatedSelection = [
                                          ...prevVisible
                                        ]
                                        updatedSelection[index] =
                                          !updatedSelection[index]
                                        return updatedSelection
                                      })
                                    }}
                                  >
                                    <Entypo
                                      name="dots-three-horizontal"
                                      size={22}
                                      color={colorPalette.skyBlue}
                                    />
                                  </TouchableOpacity>
                                </Text>
                              ) : (
                                <View></View>
                              )}
                            </View>

                            {visible2[index] && (
                              <View
                                style={{
                                  flexDirection: 'row',
                                  justifyContent: 'flex-end'
                                }}
                              >
                                <View
                                  style={{
                                    borderRadius: 10,
                                    backgroundColor: '#EFEFEF',
                                    padding: 10
                                  }}
                                >
                                  <Text
                                    style={{ color: '#000000', fontFamily: fontPalette.primaryRegular }}
                                    onPress={async () => {
                                      setVisible2((prevVisible) => {
                                        const updatedSelection = [
                                          ...prevVisible
                                        ]
                                        updatedSelection[index] =
                                          !updatedSelection[index]
                                        return updatedSelection
                                      })
                                      navigation.navigate('pickupRequest', {
                                        time_In,
                                        time_Out,
                                        dayOfMonth,
                                        dayName,
                                        shiftiD
                                      })
                                    }}
                                  >
                                    {t('Pickup Shift')}
                                  </Text>
                                </View>
                              </View>
                            )}
                            <Text style={{ fontFamily: fontPalette.primaryRegular }}>{item.shiftData.departmentName}</Text>
                          </View>
                        </View>
                      </View>
                    )
                  })
                ) : (
                  <View>
                    <Text style={{ textAlign: 'center', fontSize: 20, fontFamily: fontPalette.primaryRegular }}>
                      {t('No open shifts available')}
                    </Text>
                  </View>
                )}
              </View>
            )}
          </View>
        </Card>
      </View >
    </ScrollView >
  )
}
export default LaborSavorSchedule
